import { useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { UpdateClientEmployeeCard } from "@components/Cards";

import { routes } from "@pages/routes";

export const ClientEmployeeRecord = () => {
  const navigate = useNavigate();
  const { clientId, clientEmployeeId } = useTypedParams(
    routes.portal.clients.client.clientEmployees.clientEmployee,
  );

  const handleUpdateClientEmployeeSuccess = async () => {
    navigate(
      routes.portal.clients.client.clientEmployees.$buildPath({
        params: { clientId },
      }),
    );
  };

  return (
    <UpdateClientEmployeeCard
      clientId={clientId}
      clientEmployeeId={clientEmployeeId}
      onUpdateClientEmployeeSuccess={handleUpdateClientEmployeeSuccess}
    />
  );
};
